import { render, staticRenderFns } from "./SafeAreaInsetBottomFixed.vue?vue&type=template&id=5a254181&scoped=true&"
import script from "./SafeAreaInsetBottomFixed.vue?vue&type=script&lang=js&"
export * from "./SafeAreaInsetBottomFixed.vue?vue&type=script&lang=js&"
import style0 from "./SafeAreaInsetBottomFixed.vue?vue&type=style&index=0&id=5a254181&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a254181",
  null
  
)

export default component.exports